import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import "./ProfileMenu.scss"
//i18n
import { withTranslation } from "react-i18next"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const navigate = useNavigate()
  const containerRef = useRef(null)
  const userData = JSON.parse(localStorage.getItem("userData"))

  useEffect(() => {
    const handleDocumentClick = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setMenu(false)
      }
    }

    document.addEventListener("mousedown", handleDocumentClick)

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick)
    }
  }, [])

  const handleLogout = () => {
    localStorage.removeItem("userData")
    localStorage.removeItem("accessToken")
    navigate("/login")
  }

  return (
    <div className="d-inline-block position-relative" ref={containerRef}>
      <button
        type="button"
        className="btn header-item waves-effect"
        id="page-header-user-dropdown"
        onClick={() => setMenu(current => !current)}
      >
        <span className="profile-user rounded-circle">
          {userData?.userName?.charAt(0).toUpperCase()}
        </span>
      </button>
      {menu ? (
        <div
          className="dropdown-menu dropdown-menu-end show"
          style={{ display: "block" }}
        >
          <Link className="dropdown-item" to="/profile" onClick={() => setMenu(false)}>
            <i className="mdi mdi-account-circle font-size-17 text-muted align-middle me-1" />
            {props.t("Profile")}
          </Link>
          <Link
            className="dropdown-item d-flex align-items-center"
            to="/settings"
            onClick={() => setMenu(false)}
          >
            <i className="mdi mdi-cog font-size-17 text-muted align-middle me-1"></i>
            {props.t("Settings")}
          </Link>
          <button
            type="button"
            className="dropdown-item d-flex align-items-center"
            onClick={handleLogout}
          >
            <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger"></i>
            <span>{props.t("Logout")}</span>
          </button>
        </div>
      ) : null}
    </div>
  )
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(ProfileMenu)
